import React, { useContext, useEffect, useRef, useState } from "react";
import classes from "./NavMobile.module.css";
import resume from "../../../assets/resume.pdf";
import { BiMenuAltRight } from "react-icons/bi";
import { VscChromeClose } from "react-icons/vsc";
import { BsFillMoonFill, BsFillSunFill } from "react-icons/bs";

import NavItem from "./navItem/NavItem";

import { itemDetails } from "./navItem/navItemDetails";
import { ThemeContext } from "../../../ThemeProvider";

import { motion } from "framer-motion";

const NavMobile = ({ customClass }) => {
  const [menuToggle, setMenuToggler] = useState(false);

  const { dark, themeToggler } = useContext(ThemeContext);

  const ref = useRef();

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (menuToggle && ref.current && !ref.current.contains(e.target)) {
        setMenuToggler(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [menuToggle]);

  const animateFrom = { opacity: 0, x: 40 };
  const animateTo = { opacity: 1, x: 0 };

  return (
    <motion.nav
      className={customClass}
      ref={ref}
      initial={animateFrom}
      animate={animateTo}
      transition={{ delay: 0.01, duration: 0.5, type: "tween" }}
    >
      <div
        className={
          dark
            ? `${classes.nav__bar} ${classes.nav__bar__dark}`
            : classes.nav__bar
        }
      >
        {menuToggle && (
          <ul>
            {itemDetails.map((item) => (
              <NavItem
                key={item.num}
                offset={item.offset}
                to={item.to}
                name={item.name}
                num={item.num}
                isMobile={true}
                setMenuToggler={setMenuToggler}
              />
            ))}
            <li
              className={
                dark
                  ? `${classes.nav__resume} ${classes.nav__resume__dark}`
                  : classes.nav__resume
              }
            >
              <a href={resume} download onClick={() => setMenuToggler(false)}>
                Resume
              </a>
            </li>
            <li>
              <div className={classes.nav__theme}>
                {dark ? (
                  <div
                    className={
                      dark
                        ? `${classes.theme__icon} ${classes.theme__icon__dark}`
                        : classes.theme__icon
                    }
                    onClick={themeToggler}
                  >
                    <BsFillSunFill />
                  </div>
                ) : (
                  <div
                    className={
                      dark
                        ? `${classes.theme__icon} ${classes.theme__icon__dark}`
                        : classes.theme__icon
                    }
                    onClick={themeToggler}
                  >
                    <BsFillMoonFill />
                  </div>
                )}
              </div>
            </li>
          </ul>
        )}
      </div>

      {!menuToggle ? (
        <BiMenuAltRight
          className={
            dark
              ? `${classes.menu__toggle__btn} ${classes.menu__toggle__btn__dark}`
              : classes.menu__toggle__btn
          }
          onClick={() => setMenuToggler((prev) => !prev)}
        />
      ) : (
        <VscChromeClose
          className={
            dark
              ? `${classes.menu__toggle__btn} ${classes.menu__toggle__btn__dark}`
              : classes.menu__toggle__btn
          }
          onClick={() => setMenuToggler((prev) => !prev)}
        />
      )}
    </motion.nav>
  );
};

export default NavMobile;
